import { Control, Controller } from 'react-hook-form'
import { DataCell, Stack, UserAvatar } from '@viveaesthetics/shared'

import { ProviderAppointmentTimeSlotPicker } from '@/components/ProviderAppointmentTimeSlotPicker/ProviderAppointmentTimeSlotPicker'
import { useTimeSlotAnalytics } from '@/hooks/analytics/useTimeSlotAnalytics'

import { ProviderBookButtonForm } from '../ProviderBookButton.types'

interface TimeSlotStepProps {
  provider: {
    id: string
    name: string
    imgSrc: string
  }
  control: Control<ProviderBookButtonForm>
  error?: string
  onChange: (date: Date) => void
}

export const TimeSlotStep = ({
  provider,
  control,
  error,
  onChange
}: TimeSlotStepProps) => {
  const { setTimeSlotAnalytics } = useTimeSlotAnalytics()

  return (
    <Stack fullHeight>
      <DataCell
        leftComponent={
          <UserAvatar
            src={provider.imgSrc}
            name={provider.name}
          />
        }
        text={provider.name}
        subText="Select an available time"
      />
      <Controller
        control={control}
        name="timeSlot"
        render={({ value }) => (
          <ProviderAppointmentTimeSlotPicker
            error={error}
            value={value}
            providerId={provider.id}
            onChange={timeSlot => {
              setTimeSlotAnalytics({
                providerId: provider.id,
                timeSlot
              })

              onChange(timeSlot)
            }}
            variant="in-modal"
          />
        )}
      />
    </Stack>
  )
}
